import React from 'react';
import { Grid } from '@material-ui/core';
import Icon from '@material-ui/core/Icon'
import { CustomInputMappingField } from '@tuqqi/common';
import { ShortTextRounded, ImportExportRounded, NoteRounded, CategoryOutlined, EventRounded, LocationOnOutlined, Functions } from '@material-ui/icons';
import { SignatureIcon } from './SignatureIcon';

interface IProps {
    field: CustomInputMappingField,
}

const renderIcon = (fieldIcon: string | null, fieldType: string) => {
    if(fieldIcon && fieldType !== 'signature') {
        return <Icon>{fieldIcon}</Icon>
    } else {
        switch (fieldType) {
            case 'signature':
                return <SignatureIcon />
            case 'text':
                return <ShortTextRounded />
            case 'article':
                return <ShortTextRounded />
            case 'paragraph':
                return <NoteRounded />
            case 'number':
                return <ImportExportRounded />
            case 'calculation':
                return <Functions />
            case 'date':
                return <EventRounded />
            case 'dateTime':
                return <EventRounded />
            case 'location':
                return <LocationOnOutlined />
            case 'multiSelect':
                return <CategoryOutlined />
            case 'select':
                return <CategoryOutlined />
            default:
                return <ShortTextRounded />
        }
    }
    
}

export default function IconField({ field }: IProps) {
    return (
        <Grid>
            {renderIcon(field.fieldIcon, field.type)}
        </Grid>
  );
}